import dashboardDoctorRoutes from "@/router/dashboard/doctor";
import dashboardAdminRoutes from "@/router/dashboard/admin";
import dashboardClinicRoutes from "@/router/dashboard/clinic";
import isSmsVerified from "@/middleware/isSmsVerified";
import auth from "@/middleware/auth";
import hasRoles from "@/middleware/hasRoles";
import isUserNotBlocked from "@/middleware/isUserNotBlocked";
import checkIsVideoInWindow from "@/middleware/checkIsVideoInWindow";
import checkIsVideoMounted from "@/middleware/checkIsVideoMounted";
import isActivatedUser from "@/middleware/isActivatedUser";
import checkAccountCompletion from "@/middleware/checkAccountCompletion";

export default {
  path: "/dashboard",
  name: "User",
  meta: {
    middlewares: [
      auth,
      hasRoles,
      isUserNotBlocked,
      isSmsVerified,
      checkIsVideoInWindow,
      checkIsVideoMounted,
      checkAccountCompletion,
    ],
  },

  component: () =>
    import(
      /* webpackChunkName: "user" */ "@/layouts/Header/HeaderLayout.ts.vue"
    ),
  children: [
    {
      path: "",
      name: "Dashboard",
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ "@/views/User/Dashboard.vue"
        ),
    },
    {
      path: "referral",
      name: "DashboardReferral",
      children: [
        {
          path: ":id",
          name: "DoctorReferral",
          meta: {
            middlewares: [auth, hasRoles, isActivatedUser],
            roles: ["doctor", "admin"],
          },
          props: (route) => ({ id: route.params.id * 1 }),
          component: () =>
            import(
              /* webpackChunkName: "referral" */ "@/views/Doctor/Referral.vue"
            ),
        },
        {
          path: ":id/detail",
          name: "PatientReferralDetail",
          props: (route) => ({ id: route.params.id * 1 }),
          component: () =>
            import(
              /* webpackChunkName: "referral" */ "@/views/Patient/ReferralsDetail.vue"
            ),
        },
        {
          path: ":id/results",
          name: "ReferralResults",
          props: (route) => ({ id: route.params.id * 1 }),
          component: () =>
            import(
              /* webpackChunkName: "referral-results" */ "@/views/User/Results.vue"
            ),
        },
      ],
    },
    {
      path: "patients",
      name: "DoctorPatientList",
      meta: {
        middlewares: [auth, hasRoles, isActivatedUser],
        roles: ["doctor", "clinic_owner"],
      },
      component: () =>
        import(
          /* webpackChunkName: "doctor-patient-list" */ "@/views/Doctor/patients/PatientList.ts.vue"
        ),
    },
    {
      path: "patients",
      meta: {
        middlewares: [
          auth,
          hasRoles,
          isActivatedUser,
          checkIsVideoInWindow,
          checkIsVideoMounted,
        ],
        roles: ["doctor", "clinic_owner"],
      },
      component: () =>
        import(
          /* webpackChunkName: "guest" */ "@/components/Layouts/Patient/PatientCard.vue"
        ),
      children: [
        {
          path: ":id",
          name: "PatientDetails",
          component: () =>
            import(
              /* webpackChunkName: "doctor-patient-details" */ "@/views/Doctor/patients/PatientDetails.ts.vue"
            ),
        },
        {
          path: ":id/upcoming-visits",
          name: "PatientUpcomingVisits",
          component: () =>
            import(
              /* webpackChunkName: "doctor-patient-upcoming-visits" */ "@/views/Doctor/patients/PatientUpcomingVisits.ts.vue"
            ),
        },
        {
          path: ":id/visits-history",
          name: "PatientVisitsHistory",
          component: () =>
            import(
              /* webpackChunkName: "doctor-patient-visits-history" */ "@/views/Doctor/patients/PatientVisitsHistory.ts.vue"
            ),
        },
        {
          path: ":id/examination-history",
          name: "PatientExaminationHistory",
          component: () =>
            import(
              /* webpackChunkName: "doctor-patient-examination-history" */ "@/views/Doctor/patients/PatientExaminationHistory.ts.vue"
            ),
        },
      ],
    },
    dashboardDoctorRoutes,
    dashboardClinicRoutes,
    dashboardAdminRoutes,
  ],
};
